var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_249_1035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.875 8H3.375V13.25H4.875V8ZM9.375 8H7.875V13.25H9.375V8ZM15.75 14.75H1.5V16.25H15.75V14.75ZM13.875 8H12.375V13.25H13.875V8ZM8.625 2.945L12.5325 5H4.7175L8.625 2.945ZM8.625 1.25L1.5 5V6.5H15.75V5L8.625 1.25Z",
    fill: "#E74242"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_249_1035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountLogout);
export default __webpack_public_path__ + "static/media/account_logout.92da8281f023a8a149872730dd6b6bc1.svg";
export { ForwardRef as ReactComponent };